var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPressReleasesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_10956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75016 10.5H5.8335",
    stroke: "#E7000B",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5002 8.16675H5.8335",
    stroke: "#E7000B",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33317 12.8334H11.6665C11.9759 12.8334 12.2727 12.7105 12.4915 12.4917C12.7103 12.2729 12.8332 11.9762 12.8332 11.6667V2.33341C12.8332 2.024 12.7103 1.72725 12.4915 1.50846C12.2727 1.28966 11.9759 1.16675 11.6665 1.16675H4.6665C4.35708 1.16675 4.06034 1.28966 3.84155 1.50846C3.62275 1.72725 3.49984 2.024 3.49984 2.33341V11.6667C3.49984 11.9762 3.37692 12.2729 3.15813 12.4917C2.93934 12.7105 2.64259 12.8334 2.33317 12.8334ZM2.33317 12.8334C2.02375 12.8334 1.72701 12.7105 1.50821 12.4917C1.28942 12.2729 1.1665 11.9762 1.1665 11.6667V6.41675C1.1665 6.10733 1.28942 5.81058 1.50821 5.59179C1.72701 5.373 2.02375 5.25008 2.33317 5.25008H3.49984",
    stroke: "#E7000B",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91683 3.5H6.41683C6.09466 3.5 5.8335 3.76117 5.8335 4.08333V5.25C5.8335 5.57217 6.09466 5.83333 6.41683 5.83333H9.91683C10.239 5.83333 10.5002 5.57217 10.5002 5.25V4.08333C10.5002 3.76117 10.239 3.5 9.91683 3.5Z",
    stroke: "#E7000B",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_10956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressReleasesIcon);
export default __webpack_public_path__ + "static/media/PressReleasesIcon.d3bab0245c36b0fc54f62c6de5340b96.svg";
export { ForwardRef as ReactComponent };